import { config } from '../_helpers';

// Public banner API exposed by the .NET 10 backend.
// Contract (per banner-api-backend-instructions.md):
//   GET {apiBaseUrl}/banner/active
//     200 -> BannerDto { id, header, footer, startDate, endDate }
//     404 -> no active banner (treat as "hide")
//     any other -> treat as "hide"
//
// The service is intentionally non-throwing: every failure path resolves to
// `null` so the React layer can never crash because of the banner.
const BANNER_PATH = '/banner/active';

export const bannerService = {
    getActive
};

function buildUrl() {
    const baseUrl = (config && config.apiBaseUrl) || (config && config.apiUrl) || 'api';
    // Trim a single trailing slash so we don't produce `api//banner/active`.
    const trimmed = String(baseUrl).replace(/\/+$/, '');
    return trimmed + BANNER_PATH;
}

function getActive() {
    return new Promise((resolve) => {
        let url;
        try {
            url = buildUrl();
        } catch (err) {
            console.warn('bannerService: failed to build URL', err);
            resolve(null);
            return;
        }

        const requestOptions = {
            method: 'GET',
            headers: { 'Accept': 'application/json' }
        };

        try {
            fetch(url, requestOptions)
                .then((response) => handleResponse(response, resolve))
                .catch((err) => {
                    // Network error / CORS / DNS — treat as "no banner".
                    console.warn('bannerService: network error', err);
                    resolve(null);
                });
        } catch (err) {
            console.warn('bannerService: fetch threw synchronously', err);
            resolve(null);
        }
    });
}

function handleResponse(response, resolve) {
    try {
        if (!response) {
            resolve(null);
            return;
        }
        // 404 is the documented "no active banner" signal.
        if (response.status === 404) {
            resolve(null);
            return;
        }
        if (!response.ok) {
            // Anything else unexpected -> hide.
            resolve(null);
            return;
        }
        response.json()
            .then((data) => {
                try {
                    resolve(parseBanner(data));
                } catch (err) {
                    console.warn('bannerService: parse error', err);
                    resolve(null);
                }
            })
            .catch((err) => {
                console.warn('bannerService: invalid JSON', err);
                resolve(null);
            });
    } catch (err) {
        console.warn('bannerService: response handler error', err);
        resolve(null);
    }
}

// Pick ONLY the documented public fields. Audit fields (createdBy, modifiedBy,
// createdTime, modifiedTime, isActive) are never read or surfaced even if a
// non-conforming backend accidentally returns them.
function parseBanner(data) {
    if (!data || typeof data !== 'object') {
        return null;
    }
    const header = typeof data.header === 'string' ? data.header : '';
    const footer = typeof data.footer === 'string' ? data.footer : null;
    if (!header && !footer) {
        return null;
    }
    return {
        id: typeof data.id === 'number' ? data.id : null,
        header: header,
        footer: footer,
        startDate: typeof data.startDate === 'string' ? data.startDate : null,
        endDate: typeof data.endDate === 'string' ? data.endDate : null
    };
}



// WEBPACK FOOTER //
// ./src/_services/banner.service.js